import { render, staticRenderFns } from "./userDashboardMeasurements.vue?vue&type=template&id=5a5ee73e&scoped=true"
import script from "./userDashboardMeasurements.vue?vue&type=script&lang=js"
export * from "./userDashboardMeasurements.vue?vue&type=script&lang=js"
import style0 from "./userDashboardMeasurements.vue?vue&type=style&index=0&id=5a5ee73e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5ee73e",
  null
  
)

export default component.exports